import { UseQueryOptions } from "react-query";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import UserBasedVenueRepository from "../../repositories/UserBasedVenueRepository";
import { UserBasedVenueSerializer } from "../../types/user-venue";

const useUserBasedVenueService = () => {
  const repository = new UserBasedVenueRepository();

  const {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    useGenericQuery,
    useGenericMutation,
    invalidateAllRepositoryQueries,
    invalidateSubcategoryQueries,
  } = useModelService(repository);

  const useCurrentVenueSession = ({
    options,
  }: {
    options?: UseQueryOptions<UserBasedVenueSerializer>;
  } = {}) => {
    return useGenericQuery<UserBasedVenueSerializer>("currentVenueSession", {
      options: {
        ...options,
      },
      config: {
        // Prevent unauthorized toast errors from popping up on desktop login page.
        showToastOnError: false,
      },
    });
  };

  const useChangeVenueSession = (id: number) => {
    return useGenericMutation<
      UserBasedVenueSerializer,
      Partial<UserBasedVenueSerializer>
    >("changeVenueSession", "PUT", {
      injects: { id },
    });
  };

  const useMutateUserVenueSession = ({
    options,
  }: {
    options?: UseQueryOptions;
  } = {}) => {
    return useUpdate({
      options: {
        onSuccess: (res) => {
          invalidateAllRepositoryQueries();
          options?.onSuccess?.(res);
        },
      },
    });
  };

  return {
    useList,
    useCreate,
    useRetrieve,
    useUpdate,
    useChangeVenueSession,
    useCurrentVenueSession,
    useMutateUserVenueSession,
    invalidateAllRepositoryQueries,
    invalidateSubcategoryQueries,
  };
};

export default useUserBasedVenueService;
